function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default async function fetchRates() {
  await sleep(2000);
  const rates = { EUR: 1, USD: 1.1, GBP: 0.9 };
  return rates;
}
